// @ts-nocheck
import { AuthProvider } from 'react-admin';
import { SimpleCrypto } from 'simple-crypto-js';
import Cookies from 'js-cookie';
import { createBrowserHistory as createHistory } from 'history';

const authProvider: AuthProvider = {
    login: ({ username, password }) => {
        // console.log('login');
        for (let item in localStorage) { // Cleanup filters
            if(item.indexOf('_Filter') > -1) {
                localStorage.removeItem(item);
            }
        }
        localStorage.setItem('username', username);

        const request = new Request(process.env.REACT_APP_AUTH_URL + '/login', {
            method: 'POST',
            body: JSON.stringify({ username, password }),
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Cache: 'no-cache',
            }),
            credentials: 'include',
        });

        return fetch(request)
            .then(response => {
                if (response.status < 200 || response.status >= 300) {
                    throw new Error(response.statusText);
                }

                return response.json();
            })
            .then((data) => {
                return Promise.resolve(checkUserProfile(data));
            });
    },
    logout: () => {
        // console.log('logout');
        localStorage.removeItem('apiKey');
        localStorage.removeItem('token');
        localStorage.removeItem('username');
        localStorage.removeItem('role');
        localStorage.removeItem('userRole');
        localStorage.removeItem('uUuid');
        localStorage.removeItem('cUuid');
        localStorage.removeItem('oUuid');
        localStorage.removeItem('firstName');
        localStorage.removeItem('lastName');
        localStorage.removeItem('timezone');
        localStorage.removeItem('login');
        localStorage.removeItem('redirect');
        localStorage.removeItem('oId');
        for (let item in localStorage) {
            if(item.indexOf('_Filter') > -1) {
                localStorage.removeItem(item);
            }
        }

        return Promise.resolve();
    },
    checkError: () => {
        //console.log('checkError');
        return Promise.resolve();
    },
    checkAuth: async () => {
        // console.log('checkAuth');
        let href = window.location.href;
        let redirect = '';
        let apiKeySet = null;
        let apiKeyCookie = null;
        let apiKey = null;

        if(Cookies.get(process.env.REACT_APP_API_KEY_COOKIE) && Cookies.get(process.env.REACT_APP_API_KEY_COOKIE).length) {
            apiKeyCookie = Cookies.get(process.env.REACT_APP_API_KEY_COOKIE);
        }

        if(!localStorage.getItem('apiKey')) {
            if (href.indexOf('apiKey') !== -1) {
                let urlToken = href.split('?');
                redirect = urlToken[0];
                let apiKeyArray = urlToken[1].split('=');
                apiKeySet = apiKeyArray[1];
                removeQuery(redirect);
            }
            apiKeySet = apiKeyCookie;
        } else {
            apiKey = localStorage.getItem('apiKey');
            if(apiKey != apiKeyCookie) {
                apiKeySet = apiKeyCookie;
            }
        }

        if (apiKeySet) {
            localStorage.setItem('apiKey', apiKeySet);
            localStorage.setItem('login', 'apikey');
            const isAuthenticated = await authenticateViaApiKey(apiKeySet);
            return isAuthenticated ? Promise.resolve() : Promise.reject();
        } else {

            if (apiKey) {
                localStorage.setItem('apiKey', apiKey);
                localStorage.setItem('login', 'apikey');
                const isAuthorised = await authenticate();
                const isAuthenticated = await authenticateViaApiKey(apiKey);
                if (isAuthenticated && isAuthorised) {
                    return Promise.resolve();
                } else {
                    return Promise.reject({ redirectTo: '/login' });
                }
            } else {
                return Promise.reject({ redirectTo: '/login' });
            }
        }
    },
    getPermissions: async () => {
        // console.log('getPermissions');

        if (localStorage.getItem('login') === 'apikey') {
            return await authenticateViaApiKey(localStorage.getItem('apiKey'));
        } else {
            const role = localStorage.getItem('role');
            // @ts-ignore
            return role ? Promise.resolve(role) : Promise.reject();
        }
        //return Promise.reject('Unknown method');
    },
    getIdentity: () => {
        // console.log('getIdentity');
        return Promise.resolve({
            id: 'user',
            fullName: 'User',
            // avatar:
            //     'data:image/jpeg;base64,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',
        });
    },
};

async function authenticateViaApiKey(apiKey) {
    localStorage.setItem('apiKey', apiKey);

    const request = await new Request(
        process.env.REACT_APP_AUTH_URL + '/user-profile',
        {
            method: 'GET',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                // Cache: 'no-cache',
                'x-api-key': apiKey ? apiKey : '',
            }),
            credentials: 'omit',
        }
    );

    return await fetch(request)
        .then(response => {
            if (response.status < 200 || response.status >= 300) {
                throw new Error(response.statusText);
            }

            return response.json();
        })
        .then((data) => {
            return Promise.resolve(checkUserProfile(data));
        });
}

function authenticate() {
    // console.log('authenticate');
    if (
        localStorage.getItem('apiKey') &&
        localStorage.getItem('token') &&
        localStorage.getItem('username') &&
        localStorage.getItem('userRole')
    ) {
        let apiKey = localStorage.getItem('apiKey')
            ? localStorage.getItem('apiKey')
            : '';
        let username = localStorage.getItem('username')
            ? localStorage.getItem('username')
            : '';
        let role = localStorage.getItem('role')
            ? localStorage.getItem('role')
            : 'ROLE_CUSTOMER';
        let userRole = localStorage.getItem('userRole')
            ? localStorage.getItem('userRole')
            : 'Customer';

        let cryptography = new SimpleCrypto(apiKey);

        let cipher = username + role + userRole;

        let token = localStorage.getItem('token')
            ? localStorage.getItem('token')
            : '';

        try {
            let decipher = cryptography.decrypt(token);
            if (cipher !== decipher) {
                // Token changed!
                return false;
            } else {
                return true;
            }
        } catch (e) {
            return false;
        }
    }
    return false;
}

async function checkUserProfile(data) {

    const { roles, uuid, username, organisationId, apiKey, firstName, lastName, organisationUuid, countryId, timezone, isPasswordInactive } = data;

    localStorage.setItem('uUuid', uuid);
    localStorage.setItem('username', username);
    localStorage.setItem('firstName', firstName);
    localStorage.setItem('lastName', lastName);
    localStorage.setItem('apiKey', apiKey);
    localStorage.setItem('role', roles.length > 0 ? roles : 'ROLE_CUSTOMER');
    localStorage.setItem('uUuid', uuid);
    localStorage.setItem('oId', organisationId);
    localStorage.setItem('oUuid', organisationUuid);
    localStorage.setItem('cId', countryId);

    // reset marketId

    let country = localStorage.getItem('cId');

    if(Cookies.get('_KEGSTARMID_') && Cookies.get('_KEGSTARMID_') !== 'undefined' && Cookies.get('_KEGSTARMID_') !== null) {
        localStorage.setItem('mId', Cookies.get('_KEGSTARMID_'));
        document.cookie = "_KEGSTARMID_=; domain=.kegstar.com; path=/;"; // remove cookie after set
    } else {
        if(!localStorage.getItem('mId') || localStorage.getItem('mId') === 'undefined'){
            localStorage.setItem('mId', country);
        }
    }

    // @ts-ignore
    let userRole = UserRole(roles) ? UserRole(roles) : 'Customer';
    let cryptography = new SimpleCrypto(apiKey);
    let cipher = cryptography.encrypt(
        localStorage.getItem('username') + roles.toString() + userRole
    );
    localStorage.setItem('token', cipher);
    localStorage.setItem(
        'timezone',  timezone ? timezone : Intl.DateTimeFormat().resolvedOptions().timeZone
    );

    // if password is inactive
    if(isPasswordInactive){
        window.location.replace(`${process.env.REACT_APP_TRACKS_PORTAL_URL}/#/settings/password/`);
    }else{
        localStorage.setItem('isPasswordInactive', isPasswordInactive);
    }

    return roles ? Promise.resolve(roles) : Promise.reject();
}

function UserRole(roles: string | string[]) {
    let role = null;
    if (!roles) return false;
    if (roles.indexOf('ROLE_CUSTOMER') > -1) {
        role = 'Customer';
    } else if (roles.indexOf('ROLE_STAFF') > -1) {
        role = 'Operations';
    } else if (roles.indexOf('ROLE_ADMIN') > -1) {
        role = 'Administrator';
    } else {
        role = 'Customer';
    }
    localStorage.setItem('userRole', role);
    return role;
}

// Remove apiKey from URL
const removeQuery = (url) => {
    const history = createHistory();
    let urlToken = url.split('/#/');
    let urlDisplay = urlToken[1];
    history.push('/#/'+urlDisplay);
};

function isValidTimeZone(tz: string | undefined) {
    if (!Intl || !Intl.DateTimeFormat().resolvedOptions().timeZone) {
        throw 'Time zones are not available in this environment';
    }

    try {
        Intl.DateTimeFormat(undefined, { timeZone: tz });
        return true;
    } catch (ex) {
        return false;
    }
}

export default authProvider;
